import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';

import Store from 'store/store';

import Bluesky from 'components/bolt/icons/bluesky';
import EMail from 'components/bolt/icons/mail';
import Facebook from 'components/bolt/icons/facebook';
import Giphy from 'components/bolt/icons/giphy';
import Instagram from 'components/bolt/icons/instagram';
import Pinterest from 'components/bolt/icons/pinterest';
import Reddit from 'components/bolt/icons/reddit';
import Snapchat from 'components/bolt/icons/snapchat';
import Spotify from 'components/bolt/icons/spotify';
import Threads from 'components/bolt/icons/threads';
import Tiktok from 'components/bolt/icons/tiktok';
import Tumblr from 'components/bolt/icons/tumblr';
import Twitch from 'components/bolt/icons/twitch';
import Twitter from 'components/bolt/icons/twitter';
import Vimeo from 'components/bolt/icons/vimeo';
import Youtube from 'components/bolt/icons/youtube';

import Link from 'components/bolt/link/link';

import s from 'components/bolt/socials/socials.sss';

// TODO: dynamic import
const icons = {
	bluesky: Bluesky,
	email: EMail,
	facebook: Facebook,
	giphy: Giphy,
	instagram: Instagram,
	pinterest: Pinterest,
	reddit: Reddit,
	snapchat: Snapchat,
	spotify: Spotify,
	threads: Threads,
	tiktok: Tiktok,
	tumblr: Tumblr,
	twitch: Twitch,
	twitter: Twitter,
	vimeo: Vimeo,
	youtube: Youtube,
};

export default class Socials extends Component {
	getIcon(id, data) {
		if (data.iconURL) {
			const src = (props.navOpen && data.iconNav) ? data.iconNav : data.iconURL;
			return <img {...attr} src={src} alt="" />;
		}
		const props = this.props;
		const Icon = icons[id];
		const attr = { class: props.iconStyle || s.icon };
		if (!Icon) return null;
		return <Icon {...attr} />;
	}

	render(props) {
		const { socials = {}, navOpen } = props;

		const accessibilityCopy = Store.get().appData?.copy?.accessibilityCopy;
		return (
			<div class={joinClasses(s.socials, props.class, navOpen && s.navOpen)}>
				{sortObjectByOrder(socials, (social, id) => (
					<Link
						class={joinClasses(!props.iconStyle && s.social, s[id])}
						href={social.destination}
						target="_blank"
						rel="noopener noreferrer"
						key={id}
						onClick={() => Store.emit('CLICKED_FOLLOW', id, { url: social.destination })}
						ariaLabel={accessibilityCopy?.$SOCIAL_ARIA?.replace('<platform>', id)}
					>
						{this.getIcon(id, social)}
					</Link>
				)).slice(0, 5)}
			</div>
		);
	}
}
